import { render, staticRenderFns } from "./IgDistribuicaoChart.vue?vue&type=template&id=bb2bb39c"
import script from "./IgDistribuicaoChart.vue?vue&type=script&lang=js"
export * from "./IgDistribuicaoChart.vue?vue&type=script&lang=js"
import style0 from "./IgDistribuicaoChart.vue?vue&type=style&index=0&id=bb2bb39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports